// PROFILE
export const SELECT_PROFILE = 'SELECT_PROFILE';
export const GET_PROFILE = 'GET_PROFILE';
export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS';
export const EDIT_PROFILE = 'EDIT_PROFILE';
export const CANCEL_EDIT_PROFILE = 'CANCEL_EDIT_PROFILE';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';
export const PROFILE_ERRORS = 'PROFILE_ERRORS';
